import { GridCellProps } from '@progress/kendo-react-grid';
import { SyntheticEvent, useCallback } from 'react';

import GridCellBase from 'src/components/GridCellBase';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useViewAccrual from 'src/hooks/useViewAccrual';

const ExpandedCell = (props: GridCellProps) => {
  const { setAccrualReport } = useViewAccrual();
  let { expanded = false } = props.dataItem;
  const { dataItem } = props;

  const handleExpendClick = useCallback(
    (e?: SyntheticEvent) => {
      setAccrualReport((prev) => {
        const prevItems = [...prev];
        const index = prevItems.findIndex((item) => item.rowId === dataItem.rowId);
        prevItems[index] = { ...prevItems[index], expanded: !prevItems[index].expanded };
        return prevItems;
      });
    },
    [dataItem.rowId, setAccrualReport]
  );

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <ExpandCollapseCell
        title="Expand/Collapse"
        expand={expanded}
        onExpand={handleExpendClick}
        plusIconColor="#0e80b4"
        minusIconColor="#0e80b4"
      />
    </GridCellBase>
  );
};

export default ExpandedCell;
